export default "__VITE_ASSET__BYsvWZJP__"